import EverTrue from 'app';
import _ from 'underscore';
import BaseRouter from 'base/base-router';
import LegacyCoreSearchController from 'apps/core-search/controllers/legacy-core-search-controller';
import ProposalDetailController from 'apps/proposals/controllers/proposal-detail-controller';

const _is_hash_id = (params) => {
  return params && params.length === 32 && params.match(/^[a-zA-Z0-9]+$/);
};

class ProposalRouter extends BaseRouter {
  static initClass() {
    this.prototype.routes = {
      proposal: 'search',
      'proposal/search/:hash_id': 'search',
      'proposal/:id': 'proposal',
    };
  }

  search(params) {
    EverTrue.execute('setBrowserTitle', 'Proposals');

    let hash_id;
    if (_is_hash_id(params)) {
      hash_id = params;
      EverTrue.track.setReferrer('shared_search');
    }

    this.currentView = <LegacyCoreSearchController type="proposals" hash_id={hash_id} />;
    EverTrue.page.mount(this.currentView);
  }

  proposal(id) {
    EverTrue.track.set('viewed', { type: 'proposal_details' });
    EverTrue.track.setReferrer('proposal_details');
    this.currentView = <ProposalDetailController id={_.toNumber(id)} />;
    EverTrue.page.mount(this.currentView);
  }
}

ProposalRouter.initClass();
export default ProposalRouter;
